import React, { InputHTMLAttributes } from 'react';

export interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  containerClassName?: string;
  // Add min and max if they aren't already part of InputHTMLAttributes or explicitly defined
  min?: string | number;
  max?: string | number;
}

const TextInput: React.FC<TextInputProps> = ({
  label,
  name,
  type = 'text',
  error,
  className = '',
  containerClassName = '',
  ...rest
}) => {
  const inputId = name || `text-input-${Math.random().toString(36).substring(7)}`;

  return (
    <div className={`w-full ${containerClassName}`}>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <input
        id={inputId}
        name={name}
        type={type}
        className={`
          block w-full px-3 py-2 border
          ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-primary-charcoal focus:border-primary-charcoal'}
          rounded-md shadow-sm placeholder-gray-400
          focus:outline-none sm:text-sm
          disabled:bg-gray-100 disabled:cursor-not-allowed
          ${className}
        `}
        {...rest} // This will include min, max if passed
      />
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </div>
  );
};

export default TextInput; 